import React from "react";

import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Icon from "./Icon";

type TopbarItemProps = {
  onRoute: (route: string) => void;
  activePath: string;
  route: {
    label: string;
    path: string;
  };
};

const TopbarItem = ({ onRoute, activePath, route }: TopbarItemProps) => {
  return (
    <StyledTopbarItemComponent
      onClick={() => onRoute(route.path)}
      className={activePath === route.path ? "active" : ""}
    >
      <Icon isActivePath={activePath === route.path} path={route.path} />
      <span>{route.label}</span>
    </StyledTopbarItemComponent>
  );
};

const StyledTopbarItemComponent = styled.div`
  padding: 1rem 0.75rem;
  cursor: pointer;
  position: relative;
  font-size: 0.875rem;
  font-family: Poppins-Medium;
  display: flex;
  align-items: center;
  &.active::before,
  &.active::after {
    content: "";
    position: absolute;
  }
  &.active {
    background: white;
  }
  > span {
    padding: 0 8px;
    padding-left: 1rem;
    color: white;
    text-decoration: none;
    line-height: 1rem;
    @media only screen and (max-width: 1200px) {
      display: none;
    }
    @media only screen and (max-width: 768px) {
      display: block;
    }
  }
  &.active > span {
    color: ${Colors.red};
    @media only screen and (max-width: 1200px) {
      display: none;
    }
    @media only screen and (max-width: 768px) {
      display: block;
    }
  }
  &.active::before {
    top: -2.5rem;
    right: 0px;
    height: 2.5rem;
    width: 1.25rem;
    box-shadow: 0 1.25rem 0 0 white;
  }
  &.active::after {
    top: 2.5rem;
    right: 0px;
    height: 2.5rem;
    width: 1.25rem;
    box-shadow: 0 -1.25rem 0 0 white;
  }
`;

export default TopbarItem;
